import React, { Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from 'react-bootstrap/lib/Alert';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormGroup from '../inputs/fg-input.js';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Button from 'react-bootstrap/lib/Button';
import { FormattedMessage } from 'react-intl';
import TranslationService from '../../services/translation-service.js';
import TranslationStore from '../../store/translation-store.js';
import { Table } from 'react-bootstrap';
import BulkImport from './teacher-bulk-import.js';
import Select from 'react-select';
import AllLanguageSelector from "../../components/inputs/all-language-selector.js";

export default class AddTranslation extends React.Component {

    constructor(props) {
        super();
        this.state = {
            onSubmit: props.onSubmit || function () { },
            uid: props.uid,
            english: '',
            relevantLanguages: [],
            handleTransUid: props.onAddUid || function () { },
        };
        this.oldUid = undefined;
    }

    componentWillMount() {
        TranslationStore.on("CHANGE", () => {
            this.setState({
                english: TranslationStore.englishTranslationOfUid,
                relevantLanguages: TranslationStore.relevantLanguages,
            })
        });
    }

    submit() {
        TranslationService.addNewTranslationForExisitingUid(this.transUid, this.translation, this.language);
        this.state.onSubmit();
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.setState({
            onSubmit: nextProps.onSubmit || function () { },
            uid: nextProps.uid,
            handleTransUid: nextProps.onAddUid || function () { },
        })

    }

    languageSelect(e) {
        this.language = e.ietf;
    }

    handleTranslationInput(e) {
        this.translation = e.target.value;
    }

    handleTransUid(e){
        this.transUid = e.target.value;
        if (this.oldUid != this.transUid) {
            this.oldUid = this.transUid;
        }
    }

    renderSubmit() {
        return React.createElement(Button, {
            onClick: function () { this.submitUid() }.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
        }, "Submit");
    }

    submitUid(){
        TranslationService.getAddNewTranslationContent(this.transUid);
    }

    render() {


        let submitButton = React.createElement(Button, {
            onClick: this.submit.bind(this),
            bsStyle: 'primary',
            className: "btn-block"
        }, "Submit");

        if (this.state.english == undefined || this.state.english == null || this.transUid == undefined) {
            return (<div>
                
                <Row>
                    <FormControl autoFocus placeholder={"Enter Uid"} type="text" onChange={this.handleTransUid.bind(this)}></FormControl>
                    {this.renderSubmit()}
                </Row>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <Row>
                    <Col sm={8}>{"This Uid Does Not Yet Exist!"}</Col>
                </Row>
            </div>)
        } else {

            return (
                <div>
                    <Row>
                        <FormControl autoFocus placeholder={"Enter Uid"} type="text" onChange={this.handleTransUid.bind(this)}></FormControl>
                        {this.renderSubmit()}
                    </Row>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <Row>
                        <Col sm={8}>{"Uid: " + this.transUid + "     " + "English: " + this.state.english}</Col>
                    </Row>
                    <p></p>
                    <AllLanguageSelector onSelect={this.languageSelect.bind(this)} />
                    <FormControl autoFocus placeholder={"Enter Translation"} type="text" onChange={this.handleTranslationInput.bind(this)}></FormControl>
                    <p></p>
                    <p></p>
                    <Row>
                        <Col sm={8}>{submitButton}</Col>
                    </Row>
                    <Table condensed striped responsive bordered>
                        <tbody>
                            {this.renderRows()}
                        </tbody>
                    </Table>
                    <p></p>
                </div>
            )
        }

    }


    renderRows() {

        var items = [];

        if (this.state.relevantLanguages == undefined) return;
        for (var idx = 0; idx < this.state.relevantLanguages.length; idx++) {
            items.push(<tr className={"animate-color p-0"}>
                {this.state.relevantLanguages[idx].language_uid}
                <td>{this.state.relevantLanguages[idx].text}</td>
            </tr>)
        }
        return items
    }


};


// WEBPACK FOOTER //
// ./src/components/forms/add-new-translation-form.js